/**
 * Drops the sort options whose field is not visible, e.g. because the table does not
 * render that column.
 */
export function getVisibleSortOptions(sortOptions, isFieldVisible) {
  return Object.fromEntries(Object.entries(sortOptions).filter(([, {
    field
  }]) => isFieldVisible(field))
  // The filtered record is intentionally partial, but the sort selector only reads
  // the entries that are left.
  );
}

/**
 * Helper function to convert a GridSortModel to a sortBy value
 * @returns A valid sortBy value
 */
export function convertGridSortModelToSortBy(gridSortModel, options) {
  // The columns definition of the table ensures that there is only one
  // sort item at the time, but since GridSortModel is always an array of sort items
  // then simply take the first item in the array.
  const gridSortItem = gridSortModel[0];
  if (!gridSortItem || !gridSortItem.field || typeof gridSortItem.field !== "string" || !gridSortItem.sort || !options.isValidSortField(gridSortItem.field)) {
    return options.defaultSortBy;
  }
  return options.getSortBy({
    field: gridSortItem.field,
    sort: gridSortItem.sort
  });
}